/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_StartInputs */



/**
* | output |
* | --- |
* | "Start" |
*
* @param {Timer_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_start = /** @type {((inputs?: Timer_StartInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_StartInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Iniciar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvia")
	return /** @type {LocalizedString} */ ("Start")
});